<template>
  <v-row
    align="center"
    justify="center"
    no-gutters
    aria-label="Home"
    :style="
      $vuetify.breakpoint.mdAndUp
        ? 'z-index: 10; margin-top:-60px !important'
        : ''
    "
  >
    <v-col cols="10" md="9" :class="$vuetify.breakpoint.xs ? '' : 'mt-10'">
      <v-row align="center" justify="start">
        <v-col cols="12" class="text-center mt-3">
          <p class="subtitle-1">
            Saludos, usted tiene a su disposición la nueva
            <b
              >Consulta de Procesos Nacional Unificada (CPNU) en su versión
              2.0</b
            >, <br />cuyo objetivo es entregar a la ciudadanía en general un
            producto uniforme donde consultar sus procesos.
          </p>
          <p>
            Es importante señalar que se podrán utilizar temporalmente las dos
            consultas de procesos existentes junto con la CPNU.
          </p>
        </v-col>
      </v-row>
      <v-row
        align="center"
        justify="center"
        v-if="!$route.meta.islogin"
        class="mb-4"
      >
        <v-col
          cols="10"
          md="3"
          sm="6"
          v-for="(item, index) in process"
          :key="index"
          class="mx-3"
        >
          <v-hover v-slot:default="{ hover }">
            <!-- <v-card
              min-width="200"
              max-width="300"
              max-height="220"
              :href="item.url"
              :target="item.url !== '/Procesos/Index'"
              :ripple="false"
              class="mx-auto"
              shaped
              :title="item.title"
            > -->
            <v-card
              min-width="200"
              max-width="300"
              max-height="220"
              :href="item.url"
              :target="item.target"
              :ripple="false"
              class="mx-auto"
              shaped
              :title="item.title"
            >
              <v-card-text
                :class="$vuetify.breakpoint.md ? 'px-1 py-0 mt-8' : 'px-1 py-5'"
              >
                <div class="text-center">
                  <img
                    :src="require(`@/assets/${item.icon}.png`)"
                    :alt="item.title + ' Thumbnail'"
                    width="180"
                  />
                </div>
                <div
                  :class="`${
                    hover
                      ? 'blueLight--text font-weight-bold'
                      : 'font-weight-bold grey--text text--darken-2'
                  } mt-6 text-center`"
                  style="line-height: 1.5"
                >
                  {{ item.title }}
                </div>
              </v-card-text>
              <v-tabs-slider
                class="barra_"
                centered
                grow
                :color="item.color"
              ></v-tabs-slider>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data: () => ({
    process: [
      {
        title: "CONSULTA DE PROCESOS NACIONAL UNIFICADA",
        icon: "cpnu",
        url: "/Procesos/Index",
        target: "_self",
        color: "#ffd20f",
      },
      {
        title: "CONSULTA DE PROCESOS",
        icon: "consulta_procesos",
        url: "https://procesos.ramajudicial.gov.co/procesoscs/",
        target: "_cs",
        color: "#4f90c8",
      },
      {
        title: "JUSTICIA XXI WEB",
        icon: "justicia",
        url:
          "https://procesojudicial.ramajudicial.gov.co/Justicia21/Administracion/Ciudadanos/frmConsulta",
        target: "_tyba",
        color: "#cb302f",
      },
    ],
  }),
};
</script>
<style  scoped>
.v-card {
  /* transition: opacity .4s ease-in-out; */
  transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.v-card:before {
  background: none !important;
}

.v-card:hover {
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
  transform: scale(1.1);
}

.barra_ {
  height: 4px;
  position: absolute;
  bottom: 0;
  width: 91%;
}
</style>